export default __webpack_public_path__ + "static/media/a4.f2182412.png";